import * as React from 'react';

import i18n from 'helper/i18n';

import { ProductWidget } from '@migros/msrc-articles';
import { FavoriteToggleParam } from 'components/hoc/Cards/withFavorite';
import Button from 'components/molecules/Button';
import { ProductWidgetConfig } from '../../../../defs/msrc';

export type FavoriteTeaserProductProps = {
	productId: number;
	favorite: boolean;
	decorator?: string;
	disableRetailerContext: boolean;
	doToggleFavorite: (params: FavoriteToggleParam) => void;
};

export type FavoriteTeaserProductState = {
	isFavorite: boolean;
};

export class FavoriteTeaserProduct extends React.Component<FavoriteTeaserProductProps, FavoriteTeaserProductState> {
	public static displayName = 'FavoriteTeaserProduct';

	public state: FavoriteTeaserProductState = {
		isFavorite: true,
	};

	public handleFavoriteToggle = () => {
		const { doToggleFavorite, productId } = this.props;
		const { isFavorite } = this.state;

		this.setState({
			isFavorite: !isFavorite,
		});

		doToggleFavorite({
			id: `${productId}`,
			externalId: `${productId}`,
			type: 'dynamicProduct',
			favorite: isFavorite,
		});
	};

	public render() {
		const { isFavorite } = this.state;
		const { disableRetailerContext, favorite, productId, decorator /* doToggleFavorite */ } = this.props;
		const optionalProps = {};

		if (decorator) {
			optionalProps['data-t-decorator'] = decorator;
		}

		if (disableRetailerContext) {
			optionalProps['data-disable-retailer-context'] = disableRetailerContext;
		}

		const {
			layout,
			headingTagsLevel,
			hideRating,
			environment,
			webAPIKey,
			language,
			filterOptions,
		} = ProductWidgetConfig;

		return (
			<div
				className="m-favorite-teaser-product"
				data-t-name="FavoriteTeaserProduct"
				data-product-id={productId}
				{...optionalProps}
			>
				<ProductWidget
					environment={environment}
					productId={productId.toString()}
					webAPIKey={webAPIKey}
					layout={layout}
					headingTagsLevel={headingTagsLevel}
					language={language}
					hideRating={hideRating}
					filterOptions={filterOptions}
				/>

				<a
					className="m-favorite-teaser-product__link js-m-favorite-teaser-product__link"
					href="/"
					target="_blank"
				>
					<div className="m-favorite-teaser-product__info" />
				</a>

				<div
					className={`m-favorite-teaser-product__notice${
						isFavorite ? '' : ' state-m-favorite-teaser-product__notice--visible'
					}`}
				>
					<span className="m-favorite-teaser-product__notice-text">
						{i18n('react.impulsCoach.components.favoriteTeaser.productRemoved')}
					</span>
				</div>

				<div className="m-favorite-teaser-product__wrap">
					<div className="m-favorite-teaser-product__like js-ui-m-favorite-teaser-product__like">
						<Button
							handleButtonClick={this.handleFavoriteToggle}
							knob={{
								modifier: 'solid',
								size: 'm',
								icon: 'heart',
								type: favorite && isFavorite ? 'like' : '',
							}}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export default FavoriteTeaserProduct;
